export default __webpack_public_path__ + "media/images/admin/chevron-up-cade6a8fce8f2ac0baf93ba95f52d74e.svg";